import React, { Component } from "react";
import { Container, Row, Col } from "reactstrap";
import { sendData } from "../../analytics/sendData";
import { FormattedMessage } from "react-intl";
import { config } from "./../../constants/domainConfig";
import { isGameverse, isGamiclub } from "../../constants/isGamiclub";
import { isTheGamingClubs } from "../../constants/isTheGamingClubs";
import { isGamelords } from "../../constants/productCondition";
import { isOnlyBeemobi } from "../../constants/isOnlyBeemobi";
class PrivacyPolicy extends Component {
  componentDidMount() {
    sendData("", "", "", "viewed", { page: "privacy-policy" });
    window.scrollTo(0, 0);
  }

  render() {
    if (config.subDomain === "rs" && isGamiclub) {
      return (
        <section className="terms privacy-policy">
          <Container fluid>
            <Row>
              <Col xs="12">
                <div className="terms-title-wrap">
                  <h2 className="terms-section-title">
                    Правила о приватностиО нама - GamiClub
                  </h2>
                </div>
              </Col>
            </Row>
            <Row className="no-gutters">
              <Col xs="12" className="terms-list">
                <p className="terms-para">
                  Ова смерница регулише ваше коришћење мобилне веб локације
                  GamiClub и било ког садржаја, производа и услуга доступних са
                  или преко ове веб странице.
                </p>
                <p className="terms-para">
                  Мобилну страницу и веб страницу даје на располагању GamiClub,
                  а пружа их VAN DIEMENSTRAAT 140, 1031 CN AMSTERDAM, а њена
                  придружена компанија Sam Media BV. регистрована компанија у
                  Amsterdam, која се у даљем тексту заједно назива „Компанија,
                  ми, ми, наши, сами“ . Sam Media BV. је добављач садржаја и
                  ради GamiClub. Веб локацију мобилне телефоније GamiClub
                  хостира Sam Media BV. у Amsterdam. Колективно нудимо
                  погодности за претплату на GamiClub и пружамо вам приступ
                  играма, апликацијама заснованим на претраживачу и сл.
                </p>
              </Col>
              <Col xs="12" className="terms-list">
                <h6 className="terms-title">Сврха ове Политике приватности</h6>
                <p className="terms-para">
                  Ми смо посвећени заштити и очувању приватности ваших личних
                  података придржавајући се свих важећих и потребних смерница о
                  приватности, укључујући Србији закон о заштити личних
                  података.
                </p>
                <p className="terms-para">
                  Ова Политика приватности која се назива „Политика“ је јавни
                  документ који утврђује наш приступ у вези са нашим поступањем
                  и руковањем личним подацима које можемо прикупити од вас или о
                  вама. Издваја наше праксе око прикупљања, коришћења,
                  откривања, безбедности, складиштења, чувања евиденција,
                  одржавања и прекограничне размене информација (по потреби)
                  ваших личних података.
                </p>
                <p className="terms-para">
                  Ова Правила су инкорпорирана у Увјете и одредбе GamiClub и
                  мобилну страницу GamiClub. Прихватањем GamiClub Услова и
                  услова прихватате ову Политику. Копија ове Политике може вам
                  се послати / послати е-поштом на ваш захтев.
                </p>
              </Col>
              <Col xs="12" className="terms-list">
                <h6 className="terms-title">Разматрање личних података</h6>
                <p className="terms-para">
                  Да бисмо вам пружили услугу претплате на GamiClub, морамо
                  прикупити одређене информације о вама. Лични подаци које
                  можемо прикупити о вама укључују, али нису ограничени на ваш
                  мобилни број и ваше име. У случају да се од нас може затражити
                  прикупљање додатних или додатних информација о вама како бисмо
                  вам пружили наше производе, услуге, ми ћемо се побринути да
                  добијемо вашу сагласност и о томе вас обавестимо.
                </p>
              </Col>
              <Col xs="12" className="terms-list">
                <h6 className="terms-title">Прикупљање личних података</h6>
                <p className="terms-para">
                  Личне податке прикупљамо путем бројних канала, укључујући:
                </p>
                <p className="terms-para">
                  Директно од вас, укључујући, али није ограничено на: Када на
                  нашим мобилним веб локацијама унесете тражене податке о
                  претплати. Када учествујете у нашим различитим промоцијама и
                  анкетама Од трећих страна, попут наших повезаних партнера,
                  вашег мобилног оператера.
                </p>
                <p className="terms-para">
                  Ваше личне податке прикупљамо углавном да бисмо вам испоручили
                  наше производе и услуге, на пример услугу претплате GamiClub,
                  а потом и за:
                </p>
                <p className="terms-para">
                  Наплата и управљање рачунима; Служба за кориснике и помоћ;
                  Пружимо вам даље информације о нашим промоцијама, производима,
                  услугама које нудимо ми и наши партнери; Или ако и када то
                  захтева закон.
                </p>
              </Col>
              <Col xs="12" className="terms-list">
                <h6 className="terms-title">Осетљиве информације</h6>
                <p className="terms-para">
                  Осетљиве информације су дефинисане као детаљи о вашој раси,
                  етничкој припадности, верским веровањима, роду итд. Генерално
                  гледано, не прикупљамо нити су нам потребне осетљиве
                  информације о вама у сврху пружања наших производа и услуга. У
                  случају да је то потребно, ми ћемо то учинити тако што ћемо
                  обезбедити да добијемо вашу сагласност и прикупљене податке
                  ћемо користити само у сврху у коју сте пружили осетљиве
                  податке.
                </p>
                <p className="terms-para">
                  Употреба / откривање личних података
                </p>
              </Col>
              <Col xs="12" className="terms-list">
                <h6 className="terms-title">Основна сврха</h6>
                <p className="terms-para">
                  Омогућавајући вам GamiClub производ и услуге које сте
                  затражили / претплатили, ми ћемо открити ваше личне податке
                  трећим лицима ван компаније, као што је ваш мобилни телефон,
                  да осигурамо наплату накнада. Ваши лични подаци се откривају
                  овим организацијама само у односу на нас који пружамо /
                  подржавамо тражене / претплаћене услуге по вашем захтеву.
                </p>
                <p className="terms-para">
                  Компанија такође може да користи информације о технологији
                  које су прикупљене да би (1) пратили употребу особе GamiClub,
                  (2) да би одредили која подручја мобилних локација компаније
                  се најчешће користе. Ове информације нам помажу да боље
                  разумемо интернетско корисничко искуство појединаца ради даљег
                  побољшања / унапређења наших производа и услуга и циљаног
                  оглашавања и промоција.
                </p>
              </Col>
              <Col xs="12" className="terms-list">
                <h6 className="terms-title">
                  Ми такође можемо открити ваше личне податке:
                </h6>
                <p className="terms-para">
                  Државна и регулаторна тела према закону или овлашћеним
                  законима, укључујући, али не ограничавајући се на одговор на
                  позиве, судске налоге, налоге или правни поступак, или да на
                  други начин успоставе или изврше наша законска права или бране
                  против правних захтева или у случају да прекршите или
                  прекршите уговор с нама. Ми ћемо користити и открити ваше
                  личне податке ако верујемо да ћете наштетити имовини или
                  правима наше компаније, њених власника или особама других
                  клијената наше компаније. Коначно ћемо користити или
                  обелоданити ваше личне податке ако сматрамо да је неопходно да
                  разменимо информације у циљу истраге, спречавања или
                  предузимања радњи у вези са незаконитим активностима, сумњама
                  у превару, ситуацијама које укључују потенцијалне претње
                  физичкој безбедности било које особе, кршења наших прихватљива
                  политика компаније, Ваши правни саветници, на ваш захтев; Наши
                  професионални саветници, ревизори и правници.
                </p>
              </Col>
              <Col xs="12" className="terms-list">
                <h6 className="terms-title">Прекогранично откривање</h6>
                <p className="terms-para">
                  Од нас ће се можда тражити да пренесемо ваше личне податке
                  нашим пружаоцима услуга треће стране у јурисдикцијама ван
                  Србији. Наши партнери / провајдери услуга пружају нам хост
                  података и техничку подршку. Ови партнери / пружаоци услуга
                  подлијежу строгој контроли која штити ваше податке од
                  неовлаштене употребе или откривања и њихов приступ вашим
                  личним подацима је ограничен у мјери у којој је то потребно за
                  обављање њиховог посла. Подузимамо све разумне кораке да
                  осигурамо да се пружаоци услуга треће стране с којима се
                  бавимо обавезују на високе стандарде заштите података и да се
                  придржавају важећих прописа о заштити података у њиховим
                  надлежностима. Такве мере су јасно прописане у уговорном
                  споразуму између нас и нашег пружаоца услуга треће стране.
                  Уговори захтевају да одговарајући провајдер услуга испуњава
                  стандарде приватности које смо поставили за себе у заштити
                  ваших личних података и да поштује одговарајуће прописе о
                  приватности и заштити података. Личне податке ћемо открити
                  нашим партнерима трећих страна само горе наведеним ако сте нам
                  дали дозволу или ако се откривање односи на главни разлог због
                  којег смо прикупили податке и ако оправдано очекујете да то
                  учинимо.
                </p>
              </Col>
              <Col xs="12" className="terms-list">
                <h6 className="terms-title">
                  Суочавање са нежељеним личним подацима
                </h6>
                <p className="terms-para">
                  У случају да смо примили или наишли на нежељене личне податке
                  о вама, предузећемо све разумне кораке да утврдимо да ли су
                  информације неопходне за наше активности и пословање и да сте
                  дали сагласност за откривање података. Ако се сматра да није
                  примерено и у складу с вашом сагласношћу, утврдићемо да ли се
                  добијени подаци морају де-идентификовати / уништити и
                  предузети потребне мере за сигурно уништавање података.
                </p>
              </Col>
              <Col xs="12" className="terms-list">
                <h6 className="terms-title">Информациона сигурност</h6>
                <p className="terms-para">
                  Личне податке прикупљене у бази података чувамо на нашим
                  серверима. Предузимамо све мере предострожности како бисмо
                  обезбедили да наши рачунари имају адекватне мере заштите (као
                  што су заштитни зид, сигурно радно окружење и радни токови,
                  сигурни сервери, приступне привилегије итд.) Да би се
                  заштитили од губитка, злоупотребе и промене података у
                  контрола компаније. Без обзира на такве мере, не можемо
                  гарантовати да ће мере заштите спречити илегални приступ нашим
                  рачунарима и појединачне информације о њима украдене или
                  измењене.
                </p>
              </Col>
              <Col xs="12" className="terms-list">
                <h6 className="terms-title">Бежичне адресе</h6>
                <p className="terms-para">
                  Ако је адреса е-поште коју нам нам дате бежична адреса
                  е-поште, пристајете да примате поруке на такву адресу од
                  Компаније или њених пословних сарадника (осим и све док нисте
                  одлучили да такве поруке не примате следећи упутства у
                  одјавите део ове смернице). Схваћате да се на ове поруке
                  односе стандардне цене вашег бежичног оператера. Представљате
                  да сте власник или овлашћени корисник бежичног уређаја на
                  којем ће се поруке примати и да сте овлашћени да одобравате
                  одговарајуће трошкове
                </p>
                <p className="terms-para">
                  Ако желите да више не примате наше рекламне, маркетиншке и
                  промотивне материјале, могућност 'искључивања' вам је на
                  располагању у сваком тренутку.
                </p>
              </Col>
              <Col xs="12" className="terms-list">
                <h6 className="terms-title">Сервис кратких порука.</h6>
                <p className="terms-para">
                  Можемо учинити доступном услугу путем које можете примати
                  поруке на свом бежичном уређају путем услуге кратких порука
                  („СМС услуга“). Подаци добијени од вас у вези са овом СМС
                  услугом могу да укључују ваше име, адресу, број мобилног
                  телефона, име вашег провајдера и датум, време и садржај ваших
                  порука. Изјављујете да имате 18 година и да сте власник или
                  овлашћени корисник бежичног уређаја на којем ће се примити
                  поруке и да сте овлашћени да одобравате одговарајуће трошкове.
                  Уз било какву накнаду о којој сте обавештени, на нашу потврду
                  и сву наредну СМС преписку важе и стандардне цене слања порука
                  вашег провајдера. Све трошкове наплаћује и наплаћује ваш
                  провајдер мобилних услуга. Компанија неће бити одговорна за
                  кашњење у пријему било каквих СМС порука, јер испорука подлеже
                  ефективном преносу од вашег мрежног оператера. Услуге СМС
                  порука пружају се на АС АС ИС основи. Компанија такође може
                  добити датум, време и садржај ваших порука током коришћења СМС
                  услуге. Информације које добијемо у вези са нашом СМС услугом
                  користићемо у складу са овом Политиком приватности. Ако вам се
                  на фактури за бежични рачун наплати накнада, можемо вашем
                  оператеру доставити одговарајуће информације у вези с тим. Ваш
                  бежични оператер и други пружаоци услуга такође могу да
                  прикупљају податке о коришћењу вашег бежичног уређаја, а
                  њихову праксу регулише њихова сопствена политика. Признајете и
                  слажете се да се СМС услуга пружа путем бежичних система који
                  користе радио (и друга средства) за преношење комуникација
                  преко сложених мрежа. Не гарантујемо да ће ваша употреба СМС
                  услуге бити приватна или сигурна, и не одговарамо вам за било
                  који недостатак приватности или сигурности који можете
                  доживети. Потпуно сте одговорни за предузимање мера
                  предострожности и обезбеђивање мера безбедности које најбоље
                  одговарају ситуацији и наменској употреби СМС услуге. Такође
                  можемо приступити садржају вашег налога и бежичног налога код
                  вашег мобилног оператера у сврху препознавања и решавања
                  техничких проблема и жалби у вези са услугама. Компанија може
                  користити личне податке за пружање услуга које ст е тражили,
                  укључујући услуге које приказују прилагођени садржај и
                  оглашавање. Компанија такође може да користи личне податке за
                  ревизију, истраживање и анализу да би радила и побољшала наше
                  технологије и услуге. Компанија може делити збирне и неособне
                  податке са пословним сарадницима трећих лица. Када компанија
                  користи пословне сараднике да би помогли компанији у обради
                  ваших личних података, компанија захтева да се они придржавају
                  наших смерница о приватности и било које друге одговарајуће
                  мере поверљивости и безбедности. Компанија може такође делити
                  информације са трећим лицима, укључујући, али не
                  ограничавајући се на њих, на поштовање законског поступка,
                  спречавање преваре или непосредне штете и осигурање
                  безбедности наше мреже и услуга. Можете да уклоните своје
                  податке из базе података компаније. Ако уклоните своје податке
                  из базе података компаније, предузеће их више неће користити у
                  секундарне сврхе, откриће их трећим лицима или их користи
                  компанија или треће стране како би вам послали промотивну
                  кореспонденцију. Можете уклонити своје податке слањем писменог
                  захтева путем е-маила на адресу: sammedia.rs@silverlines.info
                </p>
                <p className="terms-para">Приступ и исправка личних података</p>
              </Col>
              <Col xs="12" className="terms-list">
                <h6 className="terms-title">Приступ</h6>
                <p className="terms-para">
                  Имате право да приступите личним подацима које можемо имати о
                  вама било када:
                </p>
                <p className="terms-para">
                  Контактирајте нас путем е-маила за корисничку подршку на
                  sammedia.rs@silverlines.info Контактирање службеника за
                  заштиту приватности путем е-поште или поште;
                </p>
                <p className="terms-para">
                  Постоје околности према важећим законима о приватности у
                  којима вам не можемо дати приступ личним подацима које имамо о
                  вама. На пример, не можемо вам дати приступ ако би неразумно
                  утицао на туђу приватност или ако би вам пружио приступ
                  озбиљно угрожавао нечији живот, здравље и безбедност.
                </p>
                <p className="terms-para">
                  Приступ личним подацима које имамо о вама углавном нема
                  трошкова, осим ако захтев није сложен или не захтијева много
                  ресурса. Ако се наплати, биће разумно и обавестићемо вас шта
                  ће бити тако да можете пристати на то пре него што наставимо
                </p>
              </Col>
              <Col xs="12" className="terms-list">
                <h6 className="terms-title">Исправка</h6>
                <p className="terms-para">
                  Предузећемо све разумне кораке да осигурамо да су лични подаци
                  које прикупљамо, користимо и откривамо тачни, тачни и
                  ажурирани. Да бисмо осигурали његову тачност, охрабрујемо вас
                  да нас обавестите о свим променама информација које бисмо
                  могли да имамо. Обавестите нас:
                </p>
                <p className="terms-para">
                  Ако постоје грешке у вези са информацијама које имамо;
                  Обавештавајте нас о изменама у информацијама које можемо имати
                  о вама.
                </p>
                <p className="terms-para">
                  Предузећемо све разумне кораке да ажурирамо ваше личне податке
                  у року од 30 дана од подношења захтева.
                </p>
              </Col>
              <Col xs="12" className="terms-list">
                <h6 className="terms-title">Cookies</h6>
                <p className="terms-para">
                  Компанија може користити колачиће и технологију вебмастера да
                  повеже одређене информације повезане са Интернетом о вама.
                  Поред тога, Компанија може у будућности користити друге нове и
                  еволуирајуће изворе информација. (а) Cookies. „Cookies“ су
                  функција софтвера вашег прегледача. Ако је омогућено, на ваш
                  рачунар можемо написати колачиће који могу похранити мале
                  количине података о вашој посети било којој од страница на
                  нашим веб локацијама за мобилне уређаје. Cookies нам помажу у
                  праћењу која се од наших функција највише обраћа вама и који
                  садржај сте можда видели у прошлим посетама. Када поново
                  посетите ову страницу, cookies нам могу омогућити да
                  прилагодимо наш садржај у складу са вашим жељама. Ми можемо
                  користити колачиће за: праћење броја повратних посета овој
                  страници; прикупљање и извештавање збирних, статистичких
                  информација о коришћењу веб страница; испоручују вам одређени
                  садржај на основу ваших интересовања или прошле историје
                  гледања; сачувајте лозинку ради лакшег приступа нашој веб
                  локацији. Можете онемогућити колачиће, иако веб локација можда
                  не функционише правилно за вас. Поставке прегледача могу се
                  модификовати да прихвате или одбију све колачиће или затраже
                  обавештење када је колачић подешен. Више о cookies можете
                  прочитати на хттп://цоокиецентрал.цом. Важно је знати да
                  можете очистити колачиће или дигиталне идентификаторе са свог
                  уређаја, а такође онемогућити будућу употребу истих променом
                  безбедносних поставки на вашем веб претраживачу. Да бисте
                  користили све карактеристике и функционалности сајтова
                  компаније Мобиле, морате да прихватите колачиће. (б) Веб
                  светилице. Веб беацон је програмски код који се може користити
                  за приказивање слике на веб страници, али се такође може
                  користити за преношење ваше јединствене идентификације
                  корисника у базу података и повезивање са претходно стеченим
                  информацијама о појединцу у бази података. Ово омогућава
                  компанији да прати одређене мобилне сајтове које посећујете.
                  Веб беацонс користе се за праћење навика у понашању на мрежи у
                  маркетиншке сврхе како би се одредили производи или услуге
                  који би вас могли занимати. Поред тога што користи веб беацонс
                  на веб страницама, Цомпани користи и веб беацонс у е-порукама
                  које се шаљу појединцима наведеним у бази података компаније.
                  (ц) ИП адресе. Компанија аутоматски прати одређене информације
                  на основу вашег понашања на веб локацији. Ове информације
                  можемо користити за интерно истраживање демографије, интереса
                  и понашања наших корисника да боље разумемо, заштитимо и
                  служимо вама и нашој заједни
                </p>
              </Col>
            </Row>
          </Container>
        </section>
      );
    } else if (config.subDomain === "portal" && isGameverse) {
      return (
        <section className="terms privacy-policy">
          <Row>
            <Col xs="12">
              <div className="terms-title-wrap">
                <h6 className="terms-section-title">Privatumo politika</h6>
              </div>
            </Col>
          </Row>
          <Container fluid>
            <Col xs="12" className="terms-list">
              <p className="terms-para">
                Ši Privatumo politika paaiškina mūsų įsipareigojimus ir jūsų
                teises, susijusias su jūsų informacija. Atidžiai perskaitykite
                Privatumo politiką. Jei nesutinkate su šia Privatumo politika,
                prašome nesinaudoti mūsų Svetainėmis ar Paslaugomis.
              </p>
              <p className="terms-para">
                Privatumo politika yra tinkamai integruota ir taikoma toms
                pačioms Paslaugoms ir Svetainėms, kaip nustatyta Naudojimo
                sąlygose. Bet kokie terminai, kuriuos naudojame Privatumo
                politikoje be apibrėžimų, turi tokią pačią reikšmę kaip ir
                Naudojimo sąlygose.
              </p>
            </Col>

            <Col xs="12" className="terms-list">
              <h6 className="terms-title">
                Informaciją renkame šiais būdais
              </h6>
              <p className="terms-para">
                Kai jūs mums ją pateikiate arba suteikiate leidimą ją gauti.
                Jei nuspręsite užsisakyti paslaugą iš mūsų, mes arba jūsų
                mobiliojo ryšio operatorius rinksime jūsų mokėjimo duomenis
                dėl mūsų paslaugų. Jūsų mobiliojo ryšio operatoriaus surinktiems
                paskyros ir atsiskaitymo duomenims taikoma jo privatumo
                politika.
              </p>
              <p className="terms-para">
                Techninę informaciją gauname, kai lankotės mūsų Svetainėse
                ir (arba) naudojatės Paslaugomis. Kiekvieną kartą, kai
                naudojatės mūsų Paslaugomis, galime rinkti techninę informaciją
                apie jus. Kiekvieną kartą, kai prisijungiate prie mūsų
                Paslaugų arba atsijungiate nuo jų, renkame prisijungimo
                informaciją.
              </p>
            </Col>

            <Col xs="12" className="terms-list">
              <h6 className="terms-title">
                Kaip naudojame surinktą informaciją
              </h6>
              <p className="terms-para">
                Jūsų informaciją galime naudoti šiais tikslais:
              </p>
              <p className="terms-para">• Teikti užsakytas paslaugas;</p>
              <p className="terms-para">
                • Apskaičiuoti ir surinkti mokesčius už jums suteiktas
                paslaugas.
              </p>
            </Col>

            <Col xs="12" className="terms-list">
              <h6 className="terms-title">
                Kiek laiko saugome jūsų informaciją
              </h6>
              <p className="terms-para">
                Jūsų informaciją saugosime tiek laiko, kiek būtina, kad
                galėtume teikti jums savo paslaugas. Taip pat saugosime jūsų
                informaciją tiek laiko, kiek būtina, kad įvykdytume savo
                teisinius įsipareigojimus, išspręstume ginčus ir užtikrintume
                savo sutarčių vykdymą.
              </p>
              <p className="terms-para">
                Kai mums nebereikės naudoti jūsų informacijos ir jos nebereikės
                saugoti, kad įvykdytume teisinius ar reguliavimo
                įsipareigojimus, ją ištrinsime iš savo sistemų arba
                nuasmeninsime taip, kad jūsų nebūtų galima identifikuoti.
              </p>
            </Col>

            <Col xs="12" className="terms-list">
              <h6 className="terms-title">
                Kaip saugome jūsų informaciją, taip pat už ES ribų
              </h6>
              <p className="terms-para">
                Mums rūpi jūsų privatumas ir duomenys, tačiau negalime
                užtikrinti ar garantuoti bet kokios mums siunčiamos
                informacijos saugumo arba garantuoti, kad jūsų informacija
                nebus pasiekta, atskleista, pakeista ar sunaikinta pažeidus
                mūsų fizines, technines ar valdymo pramonės standartų saugumo
                priemones.
              </p>
              <p className="terms-para">
                Naudojame tinkamą duomenų rinkimo, saugojimo ir tvarkymo
                praktiką bei saugumo priemones, kad apsaugotume jūsų
                informaciją, sandorių informaciją ir mūsų Paslaugose saugomus
                duomenis nuo neteisėtos ar atsitiktinės prieigos, pakeitimo,
                atskleidimo ar sunaikinimo.
              </p>
              <p className="terms-para">
                Tačiau nė vienas duomenų perdavimo internetu ar elektroninio
                saugojimo metodas nėra 100% saugus. Todėl negalime garantuoti
                visiško saugumo. Ir toliau tobulinsime savo saugumo procedūras,
                kai atsiras naujų technologijų.
              </p>
              <p className="terms-para">
                Kadangi veikiame tarptautiniu mastu, jūsų informacija, įskaitant
                asmens duomenis, gali būti perduota ir pasiekiama Jungtinėse
                Amerikos Valstijose / Singapūre ir (arba) bet kurioje kitoje
                šalyje, nei jūsų gyvenamosios vietos šalis. Imamės visų
                pagrįstų priemonių, kad apsaugotume jūsų asmens duomenis šiose
                šalyse.
              </p>
            </Col>

            <Col xs="12" className="terms-list">
              <h6 className="terms-title">Privatumo politikos priėmimas</h6>
              <p className="terms-para">
                Naudodamiesi bet kuriomis mūsų Paslaugomis, jūs sutinkate, kad
                mes rinktume ir naudotume jūsų informaciją pagal šią Privatumo
                politiką.
              </p>
              <p className="terms-para">
                Pasiliekame teisę bet kada keisti šią Privatumo politiką,
                paskelbdami pakeitimus šiame puslapyje. Patikrinkite šio
                puslapio peržiūros datą, kad nustatytumėte, ar politika
                pasikeitė nuo paskutinio jūsų apsilankymo.
              </p>
              <p className="terms-para">
                Jei toliau naudositės bet kuria mūsų Svetainės ar Paslaugų
                dalimi po atnaujintos Privatumo politikos paskelbimo, tai
                reikš, kad sutinkate su pakeitimais.
              </p>
            </Col>

            <Col xs="12" className="terms-list">
              <h6 className="terms-title">Šios Privatumo politikos pakeitimai</h6>
              <p className="terms-para">
                Retkarčiais galime keisti savo Privatumo politiką. Jei
                nuspręsime pakeisti savo Privatumo politiką, paskelbsime šiuos
                pakeitimus šiame puslapyje, kad visada galėtumėte susipažinti
                su naujausia Privatumo politikos versija.
              </p>
            </Col>

            <Col xs="12" className="terms-list">
              <h6 className="terms-title">Kontaktai</h6>
              <p className="terms-para">
                Jei turite klausimų dėl šios Privatumo politikos, Svetainių
                praktikos ar jūsų santykių su Svetainėmis, susisiekite su mumis
                el. paštu lt@gameverse-lt.com.
              </p>
            </Col>
          </Container>
        </section>
      );
    } else
      return (
        <section className="terms privacy-policy">
          <Container fluid>
            <Row>
              <Col xs="12">
                <div className="terms-title-wrap">
                  <h2 className="terms-section-title">
                    <FormattedMessage
                      id="privacy-policy-title"
                      defaultMessage="Privacy Policy"
                    />
                  </h2>
                </div>
              </Col>
            </Row>
            {config.subDomain === "gr" && isGamelords ? (
              <Row className="no-gutters">
                <Col xs="12" className="terms-list">
                  <h6 className="terms-title">
                    <FormattedMessage
                      id="privacy-policy-gr-head1"
                      defaultMessage="1. Privacy Policy: Purposes and field of application"
                    />
                  </h6>
                  <p className="terms-para">
                    <FormattedMessage
                      id="privacy-policy-gr-Purposes-desc1"
                      defaultMessage="The hereby Praivacy Policy is referred to the Services’ provision by the company under corporate name Sam Media BV based at Van Diemenstraat 356 1013 CR Amsterdam The Netherlands with VAT NL8187 94 859 B01 which is registered with number 164831301000in relevant Chamber of Commerce (referred to as “the Company”).
        "
                    />
                  </p>
                  <p className="terms-para">
                    <FormattedMessage
                      id="privacy-policy-gr-Purposes-desc2"
                      defaultMessage="The purpose of this Privacy Policy constitutes the description of all the the means which are used for the collection and processing of the personal data that the Company receives, via the internet or other ways, as also the Company’s privacy practices."
                    />
                  </p>
                  <p className="terms-para">
                    <FormattedMessage
                      id="privacy-policy-gr-Purposes-desc3"
                      defaultMessage="The Company commits to take all necessary measurements for the protection and process of the personal data in a lawful manner, in full compliance to the General Data Protection Regulation (EU) 2016/679 (GDPR) and other related laws of its implementation. "
                    />
                  </p>
                  <p className="terms-para">
                    <FormattedMessage
                      id="privacy-policy-gr-Purposes-desc4"
                      defaultMessage="The provided Services by the Company are addressed to adults; personal data for any person, known by the Company to be aged under 18 years, are not collected, without the prior verifiable consent of the holder of parental responsibility over the child. In any case, the holder or the parental responsibility has the right, upon his/her request, to be informed regarding the information provided by the minor and/or to request its erasure. If the Company becomes aware that the person who is submitting his/her personal data is under 18 years old, the Company shall immediately erase said data."
                    />
                  </p>
                  <p className="terms-para">
                    <FormattedMessage
                      id="privacy-policy-gr-Purposes-desc5"
                      defaultMessage="The present Privacy Policy is incorporated to the General Terms and Conditions, which are posted at the Company’s website, constituting a single text. The Company’s business activities are conducted via its website https://sam-media.com/."
                    />
                  </p>
                </Col>
                <Col xs="12" className="terms-list">
                  <h6 className="terms-title">
                    <FormattedMessage
                      id="2. privacy-policy-gr-head2"
                      defaultMessage="2. Ορισμοί"
                    />
                  </h6>

                  <p className="terms-para">
                    <FormattedMessage
                      id="privacy-policy-gr-desc6"
                      defaultMessage="Personal data: any information relating to an identified or identifiable individual – natural person. The identifiable natural person means the person that his/her identity can be verified, directly or indirectly, mainly through the reference to an identifier, such as name, ID number, location data, one or more factors that characterize his/her physical, natural, psychological, financial, cultural or social identity."
                    />
                  </p>
                  <p className="terms-para">
                    <FormattedMessage
                      id="privacy-policy-gr-desc69"
                      defaultMessage="Personal Data Subject: every natural person that his/her personal data are submitted to a process by or on behalf of the Company."
                    />
                  </p>
                  <p className="terms-para">
                    <FormattedMessage
                      id="privacy-policy-gr-desc7"
                      defaultMessage="Data processing: any activity involving personal data, irrespective of the means and the procedure applied, e.g, collection, recording, use, revision, disclosure, organisation, projection and destruction of personal data"
                    />
                  </p>
                  <p className="terms-para">
                    <FormattedMessage
                      id="privacy-policy-gr-desc8"
                      defaultMessage="Processing restriction: the signaling of stored personal data in a purpose of their process in the future."
                    />
                  </p>
                  <p className="terms-para">
                    <FormattedMessage
                      id="privacy-policy-gr-desc9"
                      defaultMessage="Profiling: any form of automated processing of personal data that is consisting of the personal’s data use for the evaluation of certain personal aspects of a natural person."
                    />
                  </p>
                  <p className="terms-para">
                    <FormattedMessage
                      id="privacy-policy-gr-desc10"
                      defaultMessage="Filing System: any structured personal data set, which is accessible in accordance to specific criteria, whether this personal data set is centralized, or decentralized or distributed over an functional or geographical basis."
                    />
                  </p>
                  <p className="terms-para">
                    <FormattedMessage
                      id="privacy-policy-gr-desc11"
                      defaultMessage="Transmission: the access to personal data, for example by allowing access, broadcast or publication."
                    />
                  </p>
                  <p className="terms-para">
                    <FormattedMessage
                      id="privacy-policy-gr-desc12"
                      defaultMessage="Data Controller: the natural person or the legal entity that determines the purpose, the way, the content and the procedure of the processing of personal data."
                    />
                  </p>
                  <p className="terms-para">
                    <FormattedMessage
                      id="privacy-policy-gr-desc13"
                      defaultMessage="Data Processor: the natural person or the legal entity, which processes personal data following the controller’s instructions."
                    />
                  </p>
                  <p className="terms-para">
                    <FormattedMessage
                      id="privacy-policy-gr-desc14"
                      defaultMessage="Personal Data Subject’s Consent: any indication of will, which is free, specific, explicit and in full aware of the personal data subject; with that way the personal subject data declares that agree with the fact of his/her personal data processing, via his/her statement or his/her clear positive act."
                    />
                  </p>
                </Col>
                <Col xs="12" className="terms-list">
                  <h6 className="terms-title">
                    <FormattedMessage
                      id="privacy-policy-gr-head3"
                      defaultMessage="3. Processing Purpose of the Data"
                    />
                  </h6>

                  <p className="terms-para">
                    <FormattedMessage
                      id="privacy-policy-gr-desc15"
                      defaultMessage="The processing of personal data is exclusively realized by the Company, in accordance to the purpose that is indicated upon the collection of personal data, in the context of Services’ provision by the Company, as also every legitimate purpose."
                    />
                  </p>
                  <p className="terms-para">
                    <FormattedMessage
                      id="privacy-policy-gr-desc16"
                      defaultMessage="The collected personal data by the Company aim to facilitate the creation or improvement, as also the personalization of the relationship between the Company and recipients of its Services."
                    />
                  </p>
                  <p className="terms-para">
                    <FormattedMessage
                      id="privacy-policy-gr-desc17"
                      defaultMessage="The processing of the personal data is always conducted within the legal framework and the principles of good faith. For that reason, the personal data that are collected or are stored, are only the necessary, in order to fulfil the processing purpose. Moreover, the Company takes all the necessary measures for ensuring the legality of the said process which it should be, in any case, compliant with the purpose of data’s collection."
                    />
                  </p>
                  <p className="terms-para">
                    <FormattedMessage
                      id="privacy-policy-gr-desc18"
                      defaultMessage="The personal data processing for that purpose is lawful only if it is founded on the End User’s consent, as it is predicted to Article 6 paragraph 1a and Article 9 paragraph 2a General Data Protection Regulation (GDPR), as also the said processing is realized in the context of the contract’s performance where the End User is a contracting party, as a personal data subject. (Article 6 paragraph 1b GDPR)"
                    />
                  </p>
                </Col>
                <Col xs="12" className="terms-list">
                  <h6 className="terms-title">
                    <FormattedMessage
                      id="privacy-policy-gr-head4"
                      defaultMessage="4. Kind of the Personal Data that are collected"
                    />
                  </h6>

                  <p className="terms-para">
                    <FormattedMessage
                      id="privacy-policy-gr-desc19"
                      defaultMessage="The kind of the personal data that are collected include the full name, email address, billing information or mobile telephone number and related data, as may be requested for time to time. In any case, the said collection and processing of your personal data needs necessarily your explicit consent to the Company."
                    />
                  </p>
                </Col>
                <Col xs="12" className="terms-list">
                  <h6 className="terms-title">
                    <FormattedMessage
                      id="privacy-policy-gr-head5"
                      defaultMessage="5. Means of Collection of the Personal Data"
                    />
                  </h6>

                  <p className="terms-para">
                    <FormattedMessage
                      id="privacy-policy-gr-desc20"
                      defaultMessage="The personal data collection is conducted either because you provides them to the Company on your own or via automated means. More specifically:"
                    />
                  </p>
                  <p className="terms-para terms-para-xs">
                    <FormattedMessage
                      id="privacy-policy-gr-desc211"
                      defaultMessage="Provision of the Personal Data voluntarily by the Data’s Subjects"
                    />
                  </p>

                  <p className="terms-para">
                    <FormattedMessage
                      id="privacy-policy-gr-desc21"
                      defaultMessage="The Company collect personal data, when you submit personal information to the latter, on your own initiative. The said collection happens to the following cases:"
                    />
                  </p>
                  <p className="terms-para">
                    <FormattedMessage
                      id="privacy-policy-gr-desc22"
                      defaultMessage="- by your subscription to the Company’s website, in order to receive recreational content Services for mobile phones, for example notification sounds, games, pictures, news and others.,"
                    />
                  </p>
                  <p className="terms-para">
                    <FormattedMessage
                      id="privacy-policy-gr-desc23"
                      defaultMessage="- by using the download links, without your subscription, to the Company’s website https://sam-media.com/, such as in cases of individual downloads or subscription via SMS by using your  mobile phone, "
                    />
                  </p>
                  <p className="terms-para">
                    <FormattedMessage
                      id="privacy-policy-gr-desc24"
                      defaultMessage="-by submitting your opinions, suggestions, comments or complaints to the Company or through any communication between you and the Company."
                    />
                  </p>
                  <p className="terms-para">
                    <FormattedMessage
                      id="privacy-policy-gr-desc25"
                      defaultMessage="- by your participation in the Company’s activities, such as competitions, games, surveys, fora,"
                    />
                  </p>
                  <p className="terms-para">
                    <FormattedMessage
                      id="privacy-policy-gr-desc26"
                      defaultMessage="- by transferring your personal data by third parties which have a cooperation relationship with the Company and they are reliable. This data’s transfer is always conducted in the context of the fulfilment of the purpose for which you submit your personal data, giving your relevant consent,"
                    />
                  </p>
                  <p className="terms-para">
                    <FormattedMessage
                      id="privacy-policy-gr-desc27"
                      defaultMessage="-by transferring your personal data to the Company through public databases."
                    />
                  </p>
                  <p className="terms-para terms-para-xs">
                    <FormattedMessage
                      id="privacy-policy-gr-desc28"
                      defaultMessage="Personal Information Collection via Automated Means (Cookies)-the Company’s Policy"
                    />
                  </p>
                  <p className="terms-para">
                    <FormattedMessage
                      id="privacy-policy-gr-desc29"
                      defaultMessage="Cookies are small text files, which are used for the storage of data that are related to you and your preferences. Every time that you visit specific websites, the cookies are placed automatically in a predetermined file in your computer by the server. The purpose of the cookies is to uniquely identify your computer to the server. In this way, it is allowed to the Company to collect information relating to the server, in order to facilitate your browse in the internet, as also to evaluate and test the function of the Company’s website."
                    />
                  </p>
                  <p className="terms-para">
                    <FormattedMessage
                      id="privacy-policy-gr-desc30"
                      defaultMessage="By using the cookies, the Company is able to identify your web browser, as also to determine whether you have downloaded the activation software, which is required in order to access specific material in the Company’s websites. Moreover, the Company may, through the cookies, determine the total number of visitors of its website and identify you when you visit again its website. Information pertaining to your activities in the Company’s website and other non-personal data may also be used, in order to be appeared only the online advertisements that the Company believes that correspond to your preferences.. "
                    />
                  </p>
                  <p className="terms-para">
                    <FormattedMessage
                      id="privacy-policy-gr-desc31"
                      defaultMessage="Cookies have the ability of storing your access code in a website that you have previously used, in order to provide easy access to this, as also storing related data to your preferences, in order to redirect you to a website adjusted to said preferences."
                    />
                  </p>
                  <p className="terms-para">
                    <FormattedMessage
                      id="privacy-policy-gr-desc32"
                      defaultMessage="Information that can be used for your identification, it is not possible to be collected through the cookies of other related identifying means. The said collection can only happen in the case that you submit on your own such information, so the automated means are going to be used to deliver additional information regarding your use of the websites and/or the interactive emails, having as an exclusive purpose of increasing their usefulness for you. Such cases are indicatively and without limitation, your subscription request for the Company’s Services or the sending of an email."
                    />
                  </p>
                  <p className="terms-para">
                    <FormattedMessage
                      id="privacy-policy-gr-desc33"
                      defaultMessage="In the majority of the browsers, they are programmed to accept cookies. Although, there is the ability for you to adjust your browser’s settings so that the latter reject downloading the cookies or to notify you each time your browser receives a cookie. It is indicated that in this case, it is possible for some pages of the Company’s website may not function properly, and you may not have access to specific applications."
                    />
                  </p>
                  <p className="terms-para">
                    <FormattedMessage
                      id="privacy-policy-gr-desc34"
                      defaultMessage="It is possible that the Company may use cookies and other similar means to associate your use of the Company’s website with personal data received by the Company or by a third party, reliable partner of the Company."
                    />
                  </p>
                  <p className="terms-para">
                    <FormattedMessage
                      id="privacy-policy-gr-desc35"
                      defaultMessage="The above mentioned case could indicatively happen if you have requested information regarding future products or promotional activities of the Company, cookies and/or your browsing history regarding your activities in the Company’s website, may allow the Company to limit the provided material to what the latter believe that you may find interesting, based on your previous online activities and preferences. In the above mentioned case that the Company intends to combine your personal data and cookies or information regarding your browsing history, the Company will necessarily request your previous express consent."
                    />
                  </p>
                  <p className="terms-para">
                    <FormattedMessage
                      id="privacy-policy-gr-desc36"
                      defaultMessage="At the Company’s website may appear third parties’ advertisements, which may also contain cookies. The said cookies are determined each time by the advertiser or the advertised entity and the Company has not the ability of controlling them. Therefore, you should refer to the advertiser’s or the advertised entity’s privacy policy, in order to ascertain if they use cookies and how."
                    />
                  </p>
                  <p className="terms-para">
                    <FormattedMessage
                      id="privacy-policy-gr-desc37"
                      defaultMessage="Finally, the technical department or other departments of the Company or its associates may automatically collect information regarding the visitors of the Company’s website for purposes of maintenance, improvement, security and other legitimately acceptable reasons. Such information may include the IP address of visitors, the browser type, the date, time and duration of the visit and specific pages that the you have visited."
                    />
                  </p>
                </Col>
                <Col xs="12" className="terms-list">
                  <h6 className="terms-title">
                    <FormattedMessage
                      id="privacy-policy-gr-head6"
                      defaultMessage="6. The Company’s Practices relating to the Personal Data collection and your notification"
                    />
                  </h6>

                  <p className="terms-para">
                    <FormattedMessage
                      id="privacy-policy-gr-desc38"
                      defaultMessage="By providing your personal data each time, the Company ensures that you have been informed about who collects your personal information, the means of their collection, the kind of their use by the Company, as also about the purpose of thei collection."
                    />
                  </p>
                  <p className="terms-para">
                    <FormattedMessage
                      id="privacy-policy-gr-desc39"
                      defaultMessage="For that reason, each time that you provide your personal data, the Company will take care of notifying you about your options regarding your personal data’s use, as also in any  case of a potential joint use of your data by the Company and third parties."
                    />
                  </p>
                  <p className="terms-para">
                    <FormattedMessage
                      id="privacy-policy-gr-desc40"
                      defaultMessage="In the event that your personal data are collected manually or by means not related to the internet (such as subscription form), the Company takes care of sending you a brief notice, whereby it describes how you may receive the Company’s entire Privacy Policy and other related information from it. In that way, your detailed notification, regarding to all related aspects of your personal data and their use by the Company, is ensured, so that you are able to give your express consent to the Company."
                    />
                  </p>
                  <p className="terms-para">
                    <FormattedMessage
                      id="privacy-policy-gr-desc41"
                      defaultMessage="At the Company’s website, it is possible to appear links that redirect you to other companies’ websites. In some of the above cases, the third parties’ websites may contain the Company’s logo, even though the fact that the Company has not their operation or the responsibility about these websites’ content. "
                    />
                  </p>
                  <p className="terms-para">
                    <FormattedMessage
                      id="privacy-policy-gr-desc42"
                      defaultMessage="At the Company’s website may also appeared advertisements from other companies, which may redirect you via a link to third parties’ websites. In that case the Company has no liability for the practices of third parties or for the privacy policies of third parties or local advertising companies on the internet. So, if you are redirected from the Company’s website via such link or by clicking on an advertisement, you should refer to the applicable privacy policy of the third party or the advertiser’s website, so that you have information about how they will handle any personal data collected from you. "
                    />
                  </p>
                </Col>
                <Col xs="12" className="terms-list">
                  <h6 className="terms-title">
                    <FormattedMessage
                      id="privacy-policy-gr-head7"
                      defaultMessage="7. Data Subject’s Rights"
                    />
                  </h6>

                  <p className="terms-para">
                    <FormattedMessage
                      id="privacy-policy-gr-desc43"
                      defaultMessage="All data subjects have the following rights, pursuant to GDPR, which the Company respects and protects:"
                    />
                  </p>
                  <p className="terms-para">
                    <FormattedMessage
                      id="privacy-policy-gr-desc43-a"
                      defaultMessage="(a) the right to be informed, means that the subject has the right, upon his/her request, of receiving information about his/her personal data that are maintained by the Company and more particularly, the kind of the data under process, who natural persons or legal entities have the right of process, as also the reasons of that"
                    />
                  </p>
                  <p className="terms-para">
                    <FormattedMessage
                      id="privacy-policy-gr-desc43-b"
                      defaultMessage="(b) the right of access, means that the subject is entitled to submit request to the Company with content of having free access to his/her personal data that are maintained by the Company"
                    />
                  </p>
                  <p className="terms-para">
                    <FormattedMessage
                      id="privacy-policy-gr-desc43-c"
                      defaultMessage="(c) right to rectification and completion, means that the subject is entitled, upon his/her notice to the Company, to request the correction of any accuracies to his/her personal data, as also the completion of any incomplete data, under the condition that these data are necessary for the purposes of the process"
                    />
                  </p>
                  <p className="terms-para">
                    <FormattedMessage
                      id="privacy-policy-gr-desc43-d"
                      defaultMessage="(d) right to erasure, means that the subject is entitled to request from the Company the erasure of his/her personal data that are collected by the Company. Although, some of the collected personal data will be erased after a specified period of retention, especially in cases that the Company is obligated by the Law to maintain the personal data or the collected data are necessary for the performance of Company’s contractual obligations towards the subject "
                    />
                  </p>
                  <p className="terms-para">
                    <FormattedMessage
                      id="privacy-policy-gr-desc43-e"
                      defaultMessage="(e) right to restriction of processing, means that the subject has the right to request the restriction of processing his/her personal data and especially: 1) if there is doubt for their accuracy, 2) if the processing is illegal, 3) if the collected data are not necessary for the data controller, 4) if he/she has objections to automated process"
                    />
                  </p>
                  <p className="terms-para">
                    <FormattedMessage
                      id="privacy-policy-gr-desc43-f"
                      defaultMessage="(f) right to data portability, means that the subject has the right to request the transfer of his/her data to another data controller"
                    />
                  </p>
                  <p className="terms-para">
                    <FormattedMessage
                      id="privacy-policy-gr-desc43-g"
                      defaultMessage="(g) right to object, means that the subject may object, at any time in the future, to his/her personal data’s process by the Company, if the Company processes his/her data on the basis of the reasons that are provided in article 6 (1e or 1f) GDPR (EU) 2016/679. If the subject objects, the Company shall stop processing his/her data, under the condition that there are no legal reasons that justify their further process. The personal data’s process for advertising purposes is not a legal reason."
                    />
                  </p>
                  <p className="terms-para">
                    <FormattedMessage
                      id="privacy-policy-gr-desc43-h"
                      defaultMessage="(h) rights relating to the automated decision-making and profiling means that the personal data subject has the right of not being subjected to decision that has been taken exclusively on the basis of an automated processing, including profiling, which produces legal effects that concern the subject or significantly affect him/her with a similar way. The above mentioned do not apply in the following cases: 1)if the decision is necessary for the conclusion or the performance of the contract between the Company and the subject, 2) if it is allowed by the Law of European Union or the Law of the member state in which is subject the data controller or 3) if there is the express consent of the personal data subject."
                    />
                  </p>
                  <p className="terms-para">
                    <FormattedMessage
                      id="privacy-policy-gr-desc43-i"
                      defaultMessage="(i) right to withdraw consent means that the subject has the right to withdraw his/her consent for his/her personal data’s process, at any time in the future.  The legitimacy of the personal data’s process is not affected by the said act, until the time of the withdrawal of his/her consent."
                    />
                  </p>
                  <p className="terms-para">
                    <FormattedMessage
                      id="privacy-policy-gr-desc43-j"
                      defaultMessage="(j) right to freeze the personal data means that in some cases that are provided by the Law, the Company will freeze the personal data of the subject, upon his/her request. Furthermore, the process of personal data is only realized to a limited extent."
                    />
                  </p>
                  <p className="terms-para">
                    <FormattedMessage
                      id="privacy-policy-gr-desc44"
                      defaultMessage="If the subject request to the Company for the discontinuance of his/her personal data’s use, the Company shall satisfy this request and shall maintain only the information necessary to comply with the national legislation. "
                    />
                  </p>
                  <p className="terms-para">
                    <FormattedMessage
                      id="privacy-policy-gr-desc45"
                      defaultMessage="The subject may contact with the Company, in order to exercise his/her rights, and the Company shall respond in a timely manner, not exceeding 30 days."
                    />
                  </p>
                </Col>
                <Col xs="12" className="terms-list">
                  <h6 className="terms-title">
                    <FormattedMessage
                      id="privacy-policy-gr-head8"
                      defaultMessage="8. The Use and The Process of Personal Data"
                    />
                  </h6>

                  <p className="terms-para">
                    <FormattedMessage
                      id="privacy-policy-gr-desc46"
                      defaultMessage="The Company is bound that will use the provided personal data, according to this Privacy Policy and exclusively for the purposes that the End User’s provided them for."
                    />
                  </p>
                  <p className="terms-para">
                    <FormattedMessage
                      id="privacy-policy-gr-desc47"
                      defaultMessage="The Company maintains the ability of using the personal data that provided to the Company upon your registration to the Company’s Services, in order to send you important information and notices regarding to your account and the services that you have requested."
                    />
                  </p>
                  <p className="terms-para">
                    <FormattedMessage
                      id="privacy-policy-gr-desc48"
                      defaultMessage="In a case of personal data collection by the Company that concerns the data’s provision directly by the himself/herself End User, when the latter requested to receive files or services from the Company, the Company will proceed to procession of the request for assistance or service, including processing the completion of the order and the payment, if any. So, the Company will not share the data with third parties, except for those that the Company uses to conduct its business (for example, the completion of the order and the payment processing), required to conclude purchases that are made by the subject and subscriptions that it has requested via https://sam-media.com/."
                    />
                  </p>
                </Col>
                <Col xs="12" className="terms-list">
                  <h6 className="terms-title">
                    <FormattedMessage
                      id="privacy-policy-gr-head9"
                      defaultMessage="9. Personal Data’s Transfer to third parties"
                    />
                  </h6>

                  <p className="terms-para">
                    <FormattedMessage
                      id="privacy-policy-gr-desc49"
                      defaultMessage="The Company undertakes the commitment of not transferring the personal data that are collected to third parties that are not related or associated with it, unless you have provided your express consent about that. If the Company receives personal data from a third party-business partner, the use of these information by the Company will be governed by the hereby Privacy Policy."
                    />
                  </p>
                  <p className="terms-para">
                    <FormattedMessage
                      id="privacy-policy-gr-desc50"
                      defaultMessage="This Privacy Policy describes the types of other companies that may wish to send you notifications about their products and services and, therefore, wish to share your personal data, under the condition that you have explicitly consented to the above. "
                    />
                  </p>
                  <p className="terms-para">
                    <FormattedMessage
                      id="privacy-policy-gr-desc51"
                      defaultMessage="The Company’s website may also be linked to websites operated by the Company’s affiliates, for example companies that are members of the Company’s Group. Although members of the Company Group abide by the rules of the Group, the subjects of the personal data should refer to the separate privacy policies and practices, which may differ in certain aspects from this Privacy Policy."
                    />
                  </p>
                  <p className="terms-para">
                    <FormattedMessage
                      id="privacy-policy-gr-desc52"
                      defaultMessage="Any third party that undertakes the processing on behalf of the Company, as indicatively and without limitation a service provider, is required to contractually agree to the processing of the personal data in accordance with this Privacy Policy; for that reason, the terms of this Policy are included in the pertinent agreements."
                    />
                  </p>
                  <p className="terms-para">
                    <FormattedMessage
                      id="privacy-policy-gr-desc53"
                      defaultMessage="It is possible the revelation of personal data to third parties only if it is necessary or if the subject expressly consents to it. The personal data should be provided anonymously, if deemed appropriate."
                    />
                  </p>
                  <p className="terms-para">
                    <FormattedMessage
                      id="privacy-policy-gr-desc54"
                      defaultMessage="Moreover, the Company may use all the personal data, in an anonymously, for research purposes."
                    />
                  </p>
                  <p className="terms-para">
                    <FormattedMessage
                      id="privacy-policy-gr-desc55"
                      defaultMessage="Third companies that are associates of the Company may offer the subjects downloads of data and files, by collecting personal data on behalf of the Company, when the subjects register or log in for individual downloads of files and services via their mobile phone. Then, the Company’s associates can share with the Company the personal data required, in order to offer the requested information, file downloads and other services. The Company’s associates also provide to subject’s mobile phone operator the required information, in order to charge him/her for the information and file downloads and other services that have been purchased."
                    />
                  </p>
                  <p className="terms-para">
                    <FormattedMessage
                      id="privacy-policy-gr-desc56"
                      defaultMessage="The Company maintains the ability of sharing subject’s personal data with its associates companies or with companies that belong to its Group of Companies, always in order to fulfil the processing purpose."
                    />
                  </p>
                  <p className="terms-para">
                    <FormattedMessage
                      id="privacy-policy-gr-desc57"
                      defaultMessage="For the achievement of all the above mentioned purposes, all of the Company’s employees receive the necessary training in personal data and data security issues. As also, for the legitimacy of employees’, officers’ and associates’ access to personal data, this access should be justified by a legitimate reason, as it is predicted by the Law."
                    />
                  </p>
                  <p className="terms-para">
                    <FormattedMessage
                      id="privacy-policy-gr-desc58"
                      defaultMessage="The Company has the right of sharing subject’s personal data with outsource associates or agents, who provide their assistance to the Company for managing its informational activities (for example completion of orders, statistical analyses). Although, in that case the above mentioned persons can only use the provided personal data, in order to provide to the Company a specific service and not for any other purpose."
                    />
                  </p>
                  <p className="terms-para">
                    <FormattedMessage
                      id="privacy-policy-gr-desc59"
                      defaultMessage="Personal data: any information relating to an identified or identifiable individual – natural person. The identifiable natural person means the person that his/her identity can be verified, directly or indirectly, mainly through the reference to an identifier, such as name, ID number, location data, one or more factors that characterize his/her physical, natural, psychological, financial, cultural or social identity."
                    />
                  </p>
                  <p className="terms-para">
                    <FormattedMessage
                      id="privacy-policy-gr-desc60"
                      defaultMessage="The Company may enter into agreements with third companies that own the technology, which allows the Company to adjust the advertising and marketing messages that the personal data’s subjects receive on the Company’s websites. Non-personal data and browsing history data about subjects’ activities on these websites may be shared with these companies, in order to achieve this adjustment. These companies will not share the said information with any third party nor use it for any other purpose. It is, nonetheless, possible for the browsing history and other demographic information to be used, anonymously, exclusively for advertising-statistical purposes by the Company or its business associates."
                    />
                  </p>
                </Col>
                <Col xs="12" className="terms-list">
                  <h6 className="terms-title">
                    <FormattedMessage
                      id="privacy-policy-gr-head10"
                      defaultMessage="10. Data Storage, Time of Retention and Security"
                    />
                  </h6>

                  <p className="terms-para">
                    <FormattedMessage
                      id="privacy-policy-gr-desc61"
                      defaultMessage="The time of personal data storage is determined by the time that is needed for the fulfilment of the purpose of its collection as also by the Law. The information relating to the storage of the personal data and the period of their retention are determined in the Data Retention Policy of the Company."
                    />
                  </p>
                  <p className="terms-para terms-para-xs">
                    <FormattedMessage
                      id="privacy-policy-gr-desc62"
                      defaultMessage="The Company takes all measures indicated by technology, organisational or no, for the purpose of safeguarding the personal data that the Company possesses against loss, theft and unauthorised use, disclosure or modification, so as ensuring their integrity, confidentiality and availability. The Company uses also reasonable methods to ensure that the personal data are accurate, updated and properly completed."
                    />
                  </p>
                </Col>
                <Col xs="12" className="terms-list">
                  <h6 className="terms-title">
                    <FormattedMessage
                      id="privacy-policy-gr-head11"
                      defaultMessage="11. Cases of the Personal Data Disclosure"
                    />
                  </h6>

                  <p className="terms-para">
                    <FormattedMessage
                      id="privacy-policy-gr-desc63"
                      defaultMessage="The Company is entitled to disclose your personal data without needing your consent, in the following cases: a) in order to protect its legitimate rights or the rights of other companies that belong to its Group of Companies or the rights of its employees, officers or associates, b) to safeguard the security of its website visitors, c) to be protected against fraud or committed criminal acts or any case of a suspicion for such act, d) for reasons relating to danger management, e) public order and security, public interest, f) in order to comply with the law or the legal procedures."
                    />
                  </p>
                </Col>
                <Col xs="12" className="terms-list">
                  <h6 className="terms-title">
                    <FormattedMessage
                      id="privacy-policy-gr-head12"
                      defaultMessage="2. Ορισμοί"
                    />
                  </h6>

                  <p className="terms-para">
                    <FormattedMessage
                      id="privacy-policy-gr-desc64"
                      defaultMessage="Personal data: any information relating to an identified or identifiable individual – natural person. The identifiable natural person means the person that his/her identity can be verified, directly or indirectly, mainly through the reference to an identifier, such as name, ID number, location data, one or more factors that characterize his/her physical, natural, psychological, financial, cultural or social identity."
                    />
                  </p>
                  <p className="terms-para">
                    <FormattedMessage
                      id="privacy-policy-gr-desc65"
                      defaultMessage="Personal data: any information relating to an identified or identifiable individual – natural person. The identifiable natural person means the person that his/her identity can be verified, directly or indirectly, mainly through the reference to an identifier, such as name, ID number, location data, one or more factors that characterize his/her physical, natural, psychological, financial, cultural or social identity."
                    />
                  </p>
                </Col>
                <Col xs="12" className="terms-list">
                  <h6 className="terms-title">
                    <FormattedMessage
                      id="privacy-policy-gr-head13"
                      defaultMessage="12. Conditions of cross-border disclosure of the Personal Data"
                    />
                  </h6>

                  <p className="terms-para">
                    <FormattedMessage
                      id="privacy-policy-gr-desc66"
                      defaultMessage="The subjects’ personal data disclosure to a third country is possible, only if the legislation of said country provides a sufficient level of data’s protection. In a different case, the personal data may only be transferred to this country, if the subject has expressly consented to their transfer or if the data protection is provided for by a relevant agreement for data’s transfer, which provides all the necessary warranties about their protection"
                    />
                  </p>
                </Col>
                <Col xs="12" className="terms-list">
                  <h6 className="terms-title">
                    <FormattedMessage
                      id="privacy-policy-gr-head14"
                      defaultMessage="13. Transfer of the Company"
                    />
                  </h6>

                  <p className="terms-para">
                    <FormattedMessage
                      id="privacy-policy-gr-desc67"
                      defaultMessage="If the Company transfers, in whole or in part, its business or sells or transfers assets or, in general, engages in a merger or transfer of its business, it is allowed to transfer subjects’ personal data to a third party as part of this transaction."
                    />
                  </p>
                </Col>
                <Col xs="12" className="terms-list">
                  <h6 className="terms-title">
                    <FormattedMessage
                      id="privacy-policy-gr-head15"
                      defaultMessage="15. Solving Personal Data’s Issues-Communication"
                    />
                  </h6>

                  <p className="terms-para">
                    <FormattedMessage
                      id="privacy-policy-gr-desc68"
                      defaultMessage='For the reason of exercising subject’s rights, for example resolving a privacy issue, for issues relating to the collection and processing of subject’s  personal data by the Company, in order to revise, rectify or erase subject’s personal data or to discontinue any future communication with the subject, the latter may contact the Company via the email address  HYPERLINK "mailto:customer.support@lilymobile.gr"sam-media.gr@cchelp.co by calling the customer service at 2112348373  or by sending a letter to the Company’s head offices at Van Diemenstraat 356 1013 CR Amsterdam The Netherlands'
                    />
                  </p>
                </Col>
              </Row>
            ) : (
              <Row className="no-gutters">
                <Col xs="12" className="terms-list">
                  <p className="terms-para">
                    <FormattedMessage
                      id="privacy-policy-desc"
                      defaultMessage="This Privacy Policy explains our commitments and your rights concerning your information.
                                    You should read the Privacy Policy carefully. If you do not agree with this Privacy Policy, 
                                    please do not use our Sites or Services. The Privacy Policy is duly incorporated and subject
                                     to the Terms of Service and governs the same Services and Sites as the ones mentioned in the 
                                     Terms of Service. Any terms we use in the Privacy Policy without defining them have the same 
                                     definition as in the Terms of Service."
                    />
                  </p>
                </Col>
                <Col xs="12" className="terms-list">
                  <h6 className="terms-title">
                    <FormattedMessage
                      id="privacy-policy-collect-info-head"
                      defaultMessage="WE COLLECT INFORMATION THE FOLLOWING WAYS:"
                    />
                  </h6>
                  <p className="terms-para">
                    <FormattedMessage
                      id="privacy-policy-collect-info-desc1"
                      defaultMessage="1. When you give it to us or give us permission to obtain it If you choose to subscribe to a Service
                                    from us, we or the mobile operator of your network will collect your information related to the
                                     payment for the subscription of our Services. Account and billing information collected by the
                                      mobile operator are subject to their respective privacy policies.   "
                    />
                  </p>
                  <p className="terms-para">
                    <FormattedMessage
                      id="privacy-policy-collect-info-desc2"
                      defaultMessage="2. We get technical information when you visit our Sites and/or Services We may collect technical information
                                    about you whenever you use our Services. We collect log data every time you log in or log out of our Services."
                    />
                  </p>
                </Col>
                <Col xs="12" className="terms-list">
                  <h6 className="terms-title">
                    <FormattedMessage
                      id="privacy-policy-how-collect-info-head"
                      defaultMessage="HOW WE USE COLLECTED INFORMATION"
                    />
                  </h6>
                  <p className="terms-para">
                    <FormattedMessage
                      id="privacy-policy-how-collect-info-subhead"
                      defaultMessage="We may use your information for the following purposes:"
                    />
                  </p>
                  <p className="terms-para">
                    ·{" "}
                    <FormattedMessage
                      id="privacy-policy-how-collect-info-desc1"
                      defaultMessage="Provide the Service(s) you request;"
                    />
                  </p>
                  <p className="terms-para">
                    .{" "}
                    <FormattedMessage
                      id="privacy-policy-how-collect-info-desc2"
                      defaultMessage="Bill and collect for the Service(s) provided to you;"
                    />
                  </p>
                </Col>
                <Col xs="12" className="terms-list">
                  <h6 className="terms-title">
                    <FormattedMessage
                      id="privacy-policy-how-long-head"
                      defaultMessage="HOW LONG WE KEEP YOUR INFORMATION"
                    />
                  </h6>
                  <p className="terms-para">
                    <FormattedMessage
                      id="privacy-policy-how-long-desc"
                      defaultMessage="We will retain your information for as long as needed to provide our Services to you. We will retain your information as necessary to comply with our legal obligations, resolve disputes and enforce our agreements.
                                    When we no longer need to use your information and there is no need for us to keep it to comply with our legal or regulatory obligations, we will either remove it from our systems or depersonalize it so that we can no longer identify you."
                    />
                  </p>
                </Col>
                <Col xs="12" className="terms-list">
                  <h6 className="terms-title">
                    <FormattedMessage
                      id="privacy-policy-how-long-protect-head"
                      defaultMessage="HOW WE PROTECT YOUR INFORMATION ALSO OUTSIDE THE EU"
                    />
                  </h6>
                  <p className="terms-para">
                    <FormattedMessage
                      id="privacy-policy-how-long-protect-desc1"
                      defaultMessage="We are concerned with protecting your privacy and data, but we cannot ensure or warrant the security of any information you transmit to us or guarantee that your information may not be accessed, disclosed, altered or destroyed by breach of any of our industry standard physical, technical or managerial safeguards. We adopt appropriate data collection, storage and processing practices and security measures to protect against unauthorized or accidental access, alteration, disclosure or destruction of your information, transaction information and data stored on our Services."
                    />
                  </p>
                  <p className="terms-para">
                    <FormattedMessage
                      id="privacy-policy-how-long-protect-desc2"
                      defaultMessage="We are concerned with protecting your privacy and data, but we cannot ensure or warrant the security of any information you transmit to us or guarantee that your information may not be accessed, disclosed, altered or destroyed by breach of any of our industry standard physical, technical or managerial safeguards. We adopt appropriate data collection, storage and processing practices and security measures to protect against unauthorized or accidental access, alteration, disclosure or destruction of your information, transaction information and data stored on our Services."
                    />
                  </p>
                  <p className="terms-para">
                    <FormattedMessage
                      id="privacy-policy-how-long-protect-desc3"
                      defaultMessage="Because we operate internationally, your information, including personal information, may be transferred to and made available in the USA/Singapore and/or any other country than your country of residence. Also in these countries, we take all reasonable care to protect your personal information."
                    />
                  </p>
                </Col>
                <Col xs="12" className="terms-list">
                  <h6 className="terms-title">
                    <FormattedMessage
                      id="privacy-policy-acceptance-head"
                      defaultMessage="ACCEPTANCE OF PRIVACY POLICY"
                    />
                  </h6>
                  <p className="terms-para">
                    <FormattedMessage
                      id="privacy-policy-acceptance-desc"
                      defaultMessage="By using any of our Services, you consent to our collection and use of your information in accordance with this Privacy Policy. We reserve the right to modify this Privacy Policy at any time by posting the changes on this page. Please check the revision date at the bottom of this page to determine if the policy has been modified since you last reviewed it. Your continued use of any portion of our Site or Services following the posting of the updated Privacy Policy will constitute your acceptance of the changes."
                    />
                  </p>
                </Col>
                <Col xs="12" className="terms-list">
                  <h6 className="terms-title">
                    <FormattedMessage
                      id="privacy-policy-changes-head"
                      defaultMessage="CHANGES TO THIS PRIVACY POLICY"
                    />
                  </h6>
                  <p className="terms-para">
                    <FormattedMessage
                      id="privacy-policy-changes-desc"
                      defaultMessage="We may make changes in our Privacy Policy from time to time. If we decide to change our Privacy Policy, we will post those changes on this page so that you can always access the latest Privacy Policy."
                    />
                  </p>
                </Col>
                <Col xs="12" className="terms-list">
                  <h6 className="terms-title">
                    <FormattedMessage
                      id="privacy-policy-contact-us"
                      defaultMessage="CONTACTING US"
                    />
                  </h6>
                  {config.subDomain === "my" ? (
                    <p className="terms-para">
                      You may contact our Customer Care Team at 03-2775 2064
                      /+6018-780 0852 or through email at cs@sam-media.com. Our
                      dedicated Customer Care Team will be more than happy to
                      answer your questions or solve any issues. Please note
                      that the operating hours for our Customer Care Team is
                      only from Monday to Friday, 9.30AM to 6.00PM.
                    </p>
                  ) : (
                    <p className="terms-para">
                      <FormattedMessage
                        id={
                          isTheGamingClubs && config.subDomain === "lt"
                            ? "privacy-policy-contact-us-desc-the-gamingclubs"
                            : isOnlyBeemobi && config.subDomain === "es2"
                              ? "privacy-policy-contact-us-desc-the-beemobi"
                              : "privacy-policy-contact-us-desc"
                        }
                        defaultMessage="If you have a question about this Privacy Policy, the practices of the Sites, or your dealings with the Sites, please contact us by sending an e-mail to support@content-clubs.com."
                      />
                    </p>
                  )}
                </Col>
              </Row>
            )}
          </Container>
        </section>
      );
  }
}

export default PrivacyPolicy;



// WEBPACK FOOTER //
// ./src/components/PrivacyPolicy/PrivacyPolicy.js